import React from "react";

import Box from "./Box";
import ProductSpin from "./ProductSpin";
import PropTypes from "prop-types";
import ProductImagesBrand from "./ProductImagesBrand";
import DesktopProductImage from "./DesktopProductImage";

function ProductImagesDesktop({ images, productSpinImages, brandImages }) {
  return (
    <Box
      display={["none", null, "grid", null]}
      gridTemplateColumns="1fr"
      gridRowGap={20}
    >
      {images.map((image) => {
        return (
          <DesktopProductImage key={image.url} image={image} sizes="50vw" />
        );
      })}
      {productSpinImages.length > 0 && (
        <ProductSpin images={productSpinImages} showFullSizeButton />
      )}
      {typeof brandImages !== "undefined" && brandImages.length > 0 && (
        <ProductImagesBrand images={brandImages} />
      )}
    </Box>
  );
}

ProductImagesDesktop.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  productSpinImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  brandImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProductImagesDesktop;
